import { Fragment } from 'react';
import { Check } from 'lucide-react';

const STEPS = [
  { number: 1, label: 'Info' },
  { number: 2, label: 'Provision' },
  { number: 3, label: 'Verify' },
];

export default function StepIndicator({ current }: { current: number }) {
  return (
    <div className="mb-8 flex w-full items-center">
      {STEPS.map((s, i) => {
        const done = s.number < current;
        const active = s.number === current;
        return (
          <Fragment key={s.number}>
            <div className="flex shrink-0 flex-col items-center gap-1">
              <div
                className={[
                  'flex h-10 w-10 items-center justify-center rounded-full text-sm font-semibold',
                  done
                    ? 'bg-success text-white'
                    : active
                      ? 'bg-accent text-white'
                      : 'bg-bg-elevated text-muted',
                ].join(' ')}
              >
                {done ? <Check size={16} /> : s.number}
              </div>
              <span
                className={[
                  'text-xs',
                  active ? 'text-primary' : 'text-muted',
                ].join(' ')}
              >
                {s.label}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <div
                className={[
                  'mx-3 mb-5 h-px flex-1',
                  done ? 'bg-success' : 'bg-white/10',
                ].join(' ')}
              />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}
